__turbopack_context__.v({
  "backButton": "not-found-module__HS70Aa__backButton",
  "button": "not-found-module__HS70Aa__button",
  "buttonContainer": "not-found-module__HS70Aa__buttonContainer",
  "buttonSpan": "not-found-module__HS70Aa__buttonSpan",
  "container": "not-found-module__HS70Aa__container",
  "description": "not-found-module__HS70Aa__description",
  "errorCode": "not-found-module__HS70Aa__errorCode",
  "errorMessage": "not-found-module__HS70Aa__errorMessage",
  "logoContainer": "not-found-module__HS70Aa__logoContainer",
  "logoGlow": "not-found-module__HS70Aa__logoGlow",
  "logoLarge": "not-found-module__HS70Aa__logoLarge",
  "overlay": "not-found-module__HS70Aa__overlay",
});
